<div class="user-info">
<img class="rounded-circle float-start"  [src]="imageToShow" alt="">
  @if (userDetails) {
    <div><b>{{userDetails.displayName}} [{{userDetails.currentRole?.Role}}]</b><br>{{userDetails.email}}</div>
  }
</div>
